// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__vduK7","ranges":"BmiRanges_ranges__2Ouz7"};